import type { BatchResponse, IDemo } from '@carboncopyco/types';
import type { RawSearchResult } from '../index';

export const flattenSearchResults = (data: BatchResponse<RawSearchResult>) => {
  return {
    ...data,
    items: data.items.map(({ item, entityType }) => {
      const isOverlay =
        entityType === 'demo' && (item as IDemo).recordingType === 'live_demo';

      return {
        entityType: isOverlay ? 'overlay' : entityType,
        ...item,
      };
    }),
  };
};
